export default "__VITE_ASSET__D_i6cUs3__"